import {get, post, put, del,postBId,putById} from "@/service/base";
import {del_auth} from "./base";

export function getVersion(data){
    return get("/v3/app/version",data)
}
//上传文件
export function postExpertFile(file){
    return post('/v3/app/version/file',file,{headers:{'Content-Type':'multipart/form-data'}})
}
// 新增
export function postVersion(data){
    return postBId('/v3/app/version',data)
}
// 修改
export function putVersion(data){
    return putById('/v3/app/version',data)
}
// 删除
export function delVersion(id){
    return del('/v3/app/version/'+id)
}
